import React from "react"
import PropTypes from "prop-types";

const variants = {
  primary: "border-white-a700 border border-solid checked:border-white-a700 checked:border-[3px] checked:border-solid checked:bg-white-a700 checked:focus:bg-white-a700 checked:focus:border-white-a700 checked:hover:bg-white-a700 checked:hover:border-white-a700",
  secondary: "border-black border border-solid checked:border-black checked:border-[3px] checked:border-solid checked:bg-black checked:focus:bg-black checked:focus:border-black checked:hover:bg-black checked:hover:border-black",
};

const sizes = {
  xs: "h-[16px] w-[16px]",
};

const CheckBox = React.forwardRef(
  (
    { 
    className = "", 
    name = "", 
    label = "", 
    id = "checkbox_id", 
    checked,
    onChange, 
    variant = "primary", 
    size = "xs", 
    ...restProps 
  }, ref
  ) => {
    const handleChange = (e) => {
      if (onChange) onChange(e?.target?.checked);
    };

    return (
    
      <div className={className + " flex items-center gap-[5px] cursor-pointer"}>
        <input
          className={`${(size && sizes[size]) || ""} ${(variant && variants[variant]) || ""}`}
          ref={ref}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          id={id}
          {...restProps}
        />
        {!!label && <label htmlFor={id}>{label}</label>}
      </div>

      
    );
  }
);

CheckBox.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  size: PropTypes.oneOf(["xs"]),
  variant: PropTypes.oneOf(["primary", "secondary"]),
};

export default CheckBox;
